import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { ICON_TYPE } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { ChartOptions, ChartType } from 'chart.js';
import html2pdf from 'html2pdf.js';
import moment from 'moment';

import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { Subscription } from 'rxjs';
import { OrderHistoryService } from 'src/app/order-history/order-history.service';
import { LoactionStripService } from 'src/app/shared/modules/location-strip/loaction-strip.service';
import * as _ from 'underscore';
import { CommonUtils } from '../../shared/utils/common.utils';
import { PaymentHistoryService } from '../payment-history.service';

@Component({
    selector: 'app-payment-history',
    templateUrl: './payment-history.component.html',
    styleUrls: ['./payment-history.component.scss'],
    standalone: false
})
export class PaymentHistoryComponent implements OnInit {

  PaymentList = [];
  totalPayments: number = 0;
  payments = [];
  userId;
  pageLength = '18 per page';
  timeFrameList = ['30 Days', '6 Months', '1 Year'];
  pageList = [this.pageLength, '36 per page', '72 per page', 'All'];
  timeFrame = '30 Days';
  fromDate: any = moment().format();
  toDate: any = moment().format();
  poNumber: any;
  order: any;
  invoice: any;
  dateError = false;
  selectedTimeFrame = '30 Days';
  pageSizeperPage = this.pageLength;
  pageSize = 18;
  curPage = 1;
  end: number;
  @ViewChild('facetsRwd', { static: false }) private readonly facetsRwd;
  singleDateError = false;
  facetsList: any = [{ type: 'timeFrame', value: '30 Days' }];
  filters = {
    fields: 'DEFAULT',
    timeFrame: '3',
    currentPage: this.curPage - 1,
    pageSize: this.pageSize,
  };

  dateFormat = 'MM/DD/YYYY';
  userDataSubscription: any;
  detailsSubscription: any;
  userInfo: any;
  FilteredData: any;
  allOrdersSubscription: any;
  xlsDownloaded: boolean = false;
  orderStatusList = ['All', 'Applied payments', 'Refunds', 'Overpayments'];
  PaymentMethodList = ['All', 'Electronic Wire', 'Credit Card', 'Check', 'ACH', 'Credit Memo', 'Credit', 'Refunds', 'Adjustment', 'Overpayments'];
  paymentMethod: any = undefined;
  orderStatusSub: Subscription;
  orderStatus = 'All'
  isFilterSelected = false;
  product: any;
  isLocationSelected: boolean;
  selectedLocations: any;
  LocationListSub: Subscription;
  @ViewChild('p1') public actionsPopup: NgbPopover;
  sortTable = {
    code: 1,
    location: 1,
    invoices: 1,
    accNo: 1,
    dueDate: 1,
    paymentDate: 1,
    invoiceNo: 1,
    poNo: 1,
    invoiceAmount: 1,
    discountAmount: 1,
    plannedAmount: 1,
    paymentMethod: 1,
    invoiceBalance: 1
  };
  sortColumnName: any = '';
  paymentSummaryList: any;
  doughnutChartLabels: any[] = [];
  doughnutChartData: any = [];
  doughnutChartType: ChartType = 'doughnut';
  doughnutChartColors = [
    {
      backgroundColor: ['#3182bd', '#800000', '#001D66', '#ff9042', '#420943', '#b8583c', '#902147', '#368911', '#06a5a1'],
    },
  ];
  paymentSummary: any;
  typeSummary: any;
  paymentFromDate: any = moment().subtract(30, 'days').calendar();
  paymentToDate: any = moment().format('L');
  paymentSummaryFilters: {};
  pieChartOptions: ChartOptions = {
    responsive: true,




    plugins: {
      tooltip: {
        enabled: false,
      }
    }
  }
  displayOnlyValues: any = [];
  filterForm: FormGroup;

  constructor(
    private readonly fb: FormBuilder,
    private readonly service: OrderHistoryService,
    private readonly user: UserAccountFacade,
    private readonly cd: ChangeDetectorRef,
    private readonly modalService: NgbModal,
    private readonly localeService: BsLocaleService,
    private readonly orderHistoryService: OrderHistoryService,
    private paymentService: PaymentHistoryService,
    private router: Router,
    private locStripService: LoactionStripService,
  ) {
    enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    enGbLocale.week.dow = 0;
    defineLocale('en-gb', enGbLocale);
    this.localeService.use('en-gb');
  }

  ngOnInit() {

















  }

  onValueChanges(): void {
    this.filterForm.get('ponumber').valueChanges.subscribe(val => {
      if (val) this.isFilterSelected = true;
    })
    this.filterForm.get('invoice').valueChanges.subscribe(val => {
      if (val) this.isFilterSelected = true;
    })
  }

  getPieChartDetailsList() {
    this.userInfo = this.user.get().subscribe((userData) => {
      this.userId = userData;
      if (userData) {
        const params = { userId: this.userId.uid };
        this.getPaymentSummaryFilter();
        this.paymentService.getPieChartDetails(params, this.paymentSummaryFilters)

        this.detailsSubscription = this.paymentService.getPieChartDetails(params, this.paymentSummaryFilters).subscribe(res => {
          if (res !== null) {
            try {
              this.paymentSummaryList = res?.paymentHistoryList;
              this.paymentSummary = res?.paymentSummary;
              this.typeSummary = Object.values(this.paymentSummary);
              this.typeSummary = this.typeSummary.map(Number);
              let typeSummary = _.reject(this.typeSummary, function (num) { return num === 0; });
              this.doughnutChartData = typeSummary;
              this.cd.detectChanges();
            }
            catch { }
          }
        });
      }
    });
  }

  getPaymentSummaryFilter() {
    this.paymentSummaryFilters = {};
    if (this.isLocationSelected) {
      if (this.selectedLocations.length > 1) {
        this.paymentSummaryFilters['accountIds'] = '';
      }
      this.selectedLocations.forEach((loc) => {
        if (this.selectedLocations.length > 1) {
          this.paymentSummaryFilters['accountIds'] = (this.paymentSummaryFilters['accountIds'] === '') ? loc.accountNumber : this.paymentSummaryFilters['accountIds'] + ',' + loc.accountNumber;
        }
        else {
          this.paymentSummaryFilters['accountIds'] = loc.accountNumber;
        }
      })
    }
    if (this.timeFrame === 'Select') {
      delete this.paymentSummaryFilters['timeFrame'];
    }
    if (this.timeFrame && !this.fromDate && !this.toDate) {
      if (this.timeFrame === '30 Days') {
        this.paymentSummaryFilters['timeFrame'] = '30 days';
      }
      if (this.timeFrame === '3 Months') {
        this.paymentSummaryFilters['timeFrame'] = '3 months';
      }
      if (this.timeFrame === '6 Months') {
        this.paymentSummaryFilters['timeFrame'] = '6 months';
      }
      if (this.timeFrame === '1 Year') {
        this.paymentSummaryFilters['timeFrame'] = '1 year';
      }
    }
    if (this.fromDate && this.toDate) {
      if (this.timeFrame === 'Select' && this.paymentSummaryFilters['timeFrame']) {
        delete this.paymentSummaryFilters['timeFrame']
      }
      this.paymentSummaryFilters['fromDate'] = moment(this.fromDate).format('MM-DD-YYYY');
      this.paymentSummaryFilters['toDate'] = moment(this.toDate).format('MM-DD-YYYY');
    }
  }

  getBackgroundColor(index) {
    return this.doughnutChartColors[0]['backgroundColor'][index]
  }

  refine(): void {
    this.modalService.open(this.facetsRwd);
  }

  hide(): void {
    this.modalService.dismissAll(this.facetsRwd);
  }

  generateInvoicePDF(invoiceNumber) {
    this.service.downloadPdf(invoiceNumber);
  }

  clearPaymentSummaryFilter() {
    if (this.timeFrame === 'Select') {
      delete this.paymentSummaryFilters['timeFrame'];
    }
    if (!this.toDate || !this.fromDate) {
      delete this.paymentSummaryFilters['toDate'];
      delete this.paymentSummaryFilters['fromDate'];
    }
    this.getPieChartDetailsList();
  }

  deletePaginationFilter() {
    let filters = this.filters;
    delete filters.currentPage;
    delete filters.pageSize;
    return filters;
  }

  getPaymentList() {
    this.userInfo = this.user.get().subscribe((userData) => {
      this.userId = userData;
      this.filters = this.getfilterQuery();
      if (userData) {
        const params = { userId: this.userId.uid };
        this.paymentService.getPaymentHistory(params, this.filters)
        this.userDataSubscription = this.paymentService.userData$.subscribe((res) => {
          if (res !== null) {
            try {
              this.PaymentList = res?.paymentHistoryList;
              this.totalPayments = res?.pagination?.totalResults;
              this.cd.detectChanges();
              this.formatOrders();
              if (this.pageSize > this.totalPayments) {
                this.end = this.totalPayments;
              } else {
                if (this.pageSize < this.totalPayments) {
                  this.end = this.pageSize * this.curPage;
                  if (this.end > this.totalPayments) {
                    this.end = this.totalPayments;
                  }
                }
              }

              this.PaymentList = CommonUtils.sortArr(
                'paymentDate',
                this.payments,
                'date',
                -1
              );
              res = null;
              this.cd.detectChanges();
            }
            catch { }
          }
        });
      }
    });
  }

  goToTransactionalPage(data: any) {
    const transactionalDetailsArray = [];
    transactionalDetailsArray.push(data);
    this.paymentSummaryList.forEach(item => {
      if ((item.clearingDocNo === data.clearingDocNo) && (item.indicator === 'H')) {
        transactionalDetailsArray.push(item);
      }
    });
    localStorage.setItem("transactionalData", JSON.stringify(transactionalDetailsArray));
    this.router.navigate(['/', 'transactionaldata']);
  }

  ngOnDestroy() {
    this.userDataSubscription?.unsubscribe();
    this.userInfo?.unsubscribe();
    this.allOrdersSubscription?.unsubscribe();
    this.detailsSubscription?.unsubscribe();
  }

  formatOrders() {
    this.payments = [];
    this.PaymentList.forEach((element) => {

      const data = {
        code: element.code,
        location: element?.location,
        invoices: element.invoiceNo,
        accountNumber: element.accountNumber,
        dueDate: element.dueDate,
        paymentDate: element.paymentDate,
        invoiceNo: element.invoiceNo,
        poNo: element.poNo,
        invoiceAmount: element.invoiceAmount,
        discountAmount: element.discountAmount,
        plannedAmount: element.plannedAmount,
        paymentMethod: element.paymentMethod,
        invoiceBalance: element.invoiceBalance,
        indicator: element.indicator,
        clearingDocNo: element.clearingDocNo,
        docType: element.docType,
        docNo: element.docNo,
        ccNum: element.ccNum
      };
      this.payments.push(data);
    });
  }

  changePageSize() {
    this.curPage = 1;
    if (this.pageSizeperPage === this.pageLength) {
      this.pageSize = 18;
    }
    if (this.pageSizeperPage === '36 per page') {
      this.pageSize = 36;
    }
    if (this.pageSizeperPage === '72 per page') {
      this.pageSize = 72;
    }
    if (this.pageSizeperPage === 'All') {
      this.pageSize = this.totalPayments;
    }
    if (this.pageSize < this.totalPayments) {
      this.end = this.pageSize;
    } else {
      this.end = this.totalPayments;
    }
    this.cd.detectChanges();
  }

  getCurrentPage(type) {
    this.curPage = type === 'prev' ? this.curPage - 1 : this.curPage + 1;
    this.cd.detectChanges();
  }

  numberOfPages() {
    if (this.PaymentList && this.totalPayments && this.pageSize > 0) {
      return Math.ceil(this.totalPayments / this.pageSize);
    } else {
      return 1;
    }
  }

  iconTypes = ICON_TYPE;

  sortColumn(event, fieldName, dataList, type): any {
    CommonUtils.onSortClick(event, fieldName, dataList, type); // Column Sorting
  }

  removeFacet(filter) {
    this.facetsList.forEach((element, index) => {
      if (element === filter) {
        this.facetsList.splice(index, 1);
        if (filter.type === 'date') {
          this.fromDate = undefined;
          this.toDate = undefined;
          this.timeFrame = 'Select';

        }
        if (filter.type === 'poNumber') {
          this.poNumber = undefined;
        }
        if (filter.type === 'orderNumber') {
          this.order = undefined;
        }
        if (filter.type === 'invoiceNumber') {
          this.invoice = undefined;
        }
        if (filter.type === 'timeFrame') {
          this.timeFrame = undefined;
          this.selectedTimeFrame = undefined;
        }
        if (filter.type === 'productName') {
          this.product = undefined;
        }
        if (filter.type === 'paymentMethod' || filter.type === 'paymentType') {
          this.paymentMethod = undefined;
        }
        this.curPage = 1;
        this.getPaymentList();
        this.clearPaymentSummaryFilter()
        this.cd.detectChanges();
      }
    });
  }

  applyFilter(type?: string) {
    if (this.fromDate && this.toDate) {
      if (this.fromDate.getTime() > this.toDate.getTime()) {
        this.dateError = true;
        return false;
      } else {
        this.dateError = false;
      }
    }
    const params = { userId: this.userId.uid };
    this.filters = this.getfilterQuery();
    this.showFacets(JSON.stringify(this.filters));
    this.filters.currentPage = 0;
    this.curPage = 1;
    this.paymentService.getPaymentHistory(params, this.filters);
    this.userDataSubscription = this.service.userData$.subscribe((res) => {
      if (res !== null) {
        this.PaymentList = res?.orders;
        this.totalPayments = res?.pagination?.totalResults;
        this.cd.detectChanges();
        this.formatOrders();
        this.PaymentList = CommonUtils.sortArr(
          'placed',
          this.payments,
          'normal',
          -1
        );
        this.cd.detectChanges();
        this.selectedTimeFrame = this.timeFrame === 'Select' ? 'ALL' : this.timeFrame;
        if (type === 'mobile') {
          this.hide();
        }
      }
    });
    this.getPieChartDetailsList();
    return true;
  }

  showFacets(data) {
    const facets = JSON.parse(data);
    delete facets.fields;
    delete facets.currentPage;
    delete facets.pageSize;
    delete facets?.sortCode;
    delete facets?.sortOrder;
    delete facets?.accountIds;
    if (facets.fromDate) {
      facets.date = `${moment(this.fromDate).format(
        this.dateFormat
      )} - ${moment(this.toDate).format(this.dateFormat)}`;
      delete facets.fromDate;
      delete facets.toDate;
    }
    if (facets.timeFrame !== 'ALL') {
      facets.timeFrame = this.timeFrame;
    } else if (facets.timeFrame !== 'ALL') {
      delete facets.timeFrame;
    }
    if (facets.productCode) {
      facets.productName = this.product.name;
      delete facets.productCode;
    }
    if (facets.statuses === 'All') {
      delete facets.statuses;
    }
    if (facets.timeFrame === 'Select') {
      delete facets.timeFrame;
    }
    this.facetsList = Object.entries(facets).map(([type, value]) => ({
      type,
      value,
    }));
  }

  getfilterQuery() {
    const data: any = {
      fields: 'DEFAULT',
      currentPage: this.curPage - 1,
      pageSize: this.pageSize,
    };
    if (this.sortColumnName !== '') {
      data.sortOrder = this.sortTable[this.sortColumnName] === 0 ? 'asc' : 'desc';
      data.sortCode = this.sortColumnName;
    }
    if (this.isLocationSelected) {
      if (this.selectedLocations.length > 1) {
        data.accountIds = '';
      }
      this.selectedLocations.forEach((loc) => {
        if (this.selectedLocations.length > 1) {
          data.accountIds = (data.accountIds === '') ? loc.accountNumber : data.accountIds + ',' + loc.accountNumber;
        }
        else {
          data.accountIds = loc.accountNumber;
        }
      })
    }
    if (this.invoice) {
      data.invoiceNumber = this.invoice;
    }
    if (this.order) {
      data.orderNumber = this.order;
    }
    if (this.poNumber) {
      data.poNumber = this.poNumber;
    }
    if (this.timeFrame && !this.fromDate && !this.toDate) {
      if (this.timeFrame === '30 Days') {
        data.timeFrame = '30 days';
        this.paymentFromDate = moment().subtract(30, 'days').calendar();
      }
      if (this.timeFrame === '3 Months') {
        data.timeFrame = '3 months';
        this.paymentFromDate = moment().subtract(3, 'months').calendar();
      }
      if (this.timeFrame === '6 Months') {
        data.timeFrame = '6 months';
        this.paymentFromDate = moment().subtract(6, 'months').calendar();
      }
      if (this.timeFrame === '1 Year') {
        data.timeFrame = '1 year';
        this.paymentFromDate = moment().subtract(1, 'years').calendar();
      }
    }
    if (this.fromDate && this.toDate) {
      if (this.timeFrame === 'Select' && data.timeFrame) {
        delete data.timeFrame;
      }
      data.fromDate = moment(this.fromDate).format('MM-DD-YYYY');
      data.toDate = moment(this.toDate).format('MM-DD-YYYY');
      this.paymentFromDate = moment(this.fromDate).format('L');
      this.paymentToDate = moment(this.toDate).format('L');
    } else if (
      (!this.fromDate && this.toDate) ||
      (this.fromDate && !this.toDate)
    ) {
      this.singleDateError = true;
    } else {

    }
    if (this.product) {
      data.productCode = this.product.code;
    }
    if (this.orderStatus) {

    }
    if (this.paymentMethod) {
      data.paymentMethod = this.paymentMethod;
    }
    if (this.paymentMethod === 'All') {
      delete data.paymentMethod;
    }
    return data;
  }

  sortColumnByApi(type) {
    this.sortTable[type] = this.sortTable[type] === 1 ? 0 : 1;
    this.sortColumnName = type;
    this.getPaymentList();
  }

  validateDate() {
    this.timeFrame = this.fromDate || this.toDate ? 'Select' : this.timeFrame;
    if (this.fromDate && this.toDate) {
      this.singleDateError = false;
      if (this.fromDate.getTime() > this.toDate.getTime()) {
        this.dateError = true;
      } else {
        this.dateError = false;
      }
      this.isFilterSelected = true;
    }
  }

  clearDateRange() {
    this.fromDate = undefined;
    this.toDate = undefined;
    this.isFilterSelected = true;
    this.cd.detectChanges()
  }

  paymentMethodSelected() {
    this.applyFilter();
    this.getPaymentList();
  }

  generateSavePdf() {
    const options = {
      margin: [10, 10, 10, 10] as [number, number, number, number],
      filename: 'Order History.pdf',
      image: { type: 'jpeg' as const },
      html2canvas: {},
      jsPDF: { orientation: 'portrait' },
    } as any;
    const element: HTMLElement | null = document.getElementById('ordersTable');
    if (element) {
      html2pdf().from(element).set(options).save();
    }
  }

  generateXls(allOrders) {
    const list = JSON.parse(JSON.stringify(allOrders));
    const orders = [];
    list.forEach((element) => {

      const invoices = Array.prototype.map
        .call(element.invoices, function (item) {
          return item.invoiceNumber;
        })
        .join(',');
      const trackingNumber = Array.prototype.map
        .call(element.tracking, function (item) {
          if (item.carrier && item.carrier !== 'YB') {
            return item.trackingNumber;
          }
        })
        .filter((item) => item !== undefined)
        .join(',');
      orders.push({

        Type: element.sapSystemType,
        'Order #': element.guid,
        Status: element.statusDisplay,
        'PO #': element.purchaseOrderNumber,
        'Invoice #': invoices,
        'Tracking #': trackingNumber,
      });
    });
    this.service.downloadXls(orders, 'OrderHistory');
    this.xlsDownloaded = true;
  }

  async generateSaveXls() {
    let xlsDownloadFilter: any = JSON.stringify(this.filters);
    this.xlsDownloaded = false;
    xlsDownloadFilter = JSON.parse(xlsDownloadFilter);
    xlsDownloadFilter.currentPage = 0;
    xlsDownloadFilter.pageSize = 1000;
    const params = { userId: this.userId.uid };
    this.service.getAllOrders(params, xlsDownloadFilter);
    this.allOrdersSubscription = this.service.allOrders$.subscribe((res) => {
      if (res !== null) {
        if (!this.xlsDownloaded) {
          this.generateXls(res?.orders);
          this.cd.detectChanges();
          this.service.allOrders?.next(null);
        }
      }
    });
  }

  clearFilters() {
    this.facetsList = [];
    this.filters = {
      fields: 'DEFAULT',
      timeFrame: 'All',
      currentPage: 0,
      pageSize: this.pageSize,
    };
    this.curPage = 1;
    this.invoice = undefined;
    this.fromDate = undefined;
    this.toDate = undefined;
    this.order = undefined;
    this.invoice = undefined;
    this.poNumber = undefined;
    this.paymentMethod = undefined;
    this.timeFrame = undefined;
    this.getPaymentList();
    this.isFilterSelected = false;
    this.product = undefined;
    this.orderStatus = 'All';
    this.selectedTimeFrame = undefined;
    this.paymentFromDate = moment().subtract(2, 'years').calendar();
    this.paymentToDate = moment().format('L')
    this.clearPaymentSummaryFilter();

  }

  onKeyPress(value: any) {
    if (value) this.isFilterSelected = true;
    this.cd.detectChanges();
  }

  getSelectedProduct(params) {
    if (params) this.isFilterSelected = true;
    this.product = params;
    this.cd.detectChanges();
  }
}
